import styled from 'styled-components'

export const NFTHistoryWrapper = styled.div`
  width: 100%;
`

export const NFTHistoryFilter = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;

    li {
      margin-right: 1rem;
      cursor: pointer;
      opacity: 0.7;
      padding-bottom: 0.5rem;

      &.active {
        opacity: 1;
        border-bottom: solid 1px;
      }

      :last-child {
        margin-right: 0;
      }
    }
  }
`

export const NFTHistoryList = styled.div`
  width: 100%;
`

export const NFTHistoryItemWrapper = styled.div`
  width: 100%;
  border: solid 1px;
  margin-bottom: 0.5rem;
  display: flex;
  padding: 1.5rem;

  .activty-link {
    display: flex;
    color: inherit;
    text-decoration: none;
    width: 100%;
    height: 100%;
  }

  .nft-history-item-image {
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1.5rem;

    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
    }

    .CryptoSealImage {
      display: flex;
      position: relative;

      .crypto-seal-character {
        width: 65px;
        height: 65px;
        position: absolute;
        top: 17px;
        left: 10px;
      }
    }

    .nft-history-item-action {
      width: 35px;
      height: 35px;
      position: absolute;
      left: -10px;
      top: -10px;

      background-color: ${({ theme }) => theme.bg7};
      padding: 0.5rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .listed {
        transform: rotate(90deg);
      }

      .removed {
        margin-left: -2px;
        margin-top: -3px;
      }

      img {
        width: 20px;
        height: 20px;
      }

      svg {
        width: 20px;
        height: 20px;
        fill: #fff;
      }
    }
  }

  .nft-history-item-meta {
    width: 100%;
    font-size: 0.8rem;

    .nft-history-item-title {
      width: 100%;
      font-size: 1rem;
      font-weight: bold;
    }

    .nft-history-item-description {
      width: 100%;
      margin-top: 1rem;
      color: inherit;
      .description-text {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
      }

      .activity-token-price {
        display: flex;
        margin: 0 0.4rem;
        align-items: flex-end;

        span {
          align-items: flex-end;
          margin-left: 0.3rem;

          img {
            width: 15px;
            height: 15px;
            margin-left: 0.3rem;
          }
        }
      }
      a {
        color: inherit;
        margin: 0 0.2rem;
      }
    }

    .nft-history-item-bottom {
      width: 100%;
      display: flex;
      margin-top: 1rem;

      .nft-history-item-timestamp {
        margin-right: 1rem;
        display: flex;
        align-items: flex-end;
      }

      .nft-history-item-hash {
        color: inherit;
        a {
          color: inherit;
        }
      }
    }
  }
`
